<template>
    <el-option
      :key="source.value"
      :label="source.label||source.name"
      :value="source.value">
    </el-option>
</template>

<script>
export default {
    name: 'item-component',
    props: {
        index: {
            type: Number
        },
        source: {
            type: Object,
            default () {
                return {}
            }
        },
        name: {
            type: String
        },
        value: {
            type: String
        }

    }
}
</script>
